export default __webpack_public_path__ + "static/media/star_rating.c51bb1fe.mp4";